import { render, staticRenderFns } from "./produksimpananberjangka.vue?vue&type=template&id=ff8cdc12&scoped=true&"
import script from "./produksimpananberjangka.vue?vue&type=script&lang=js&"
export * from "./produksimpananberjangka.vue?vue&type=script&lang=js&"
import style0 from "./produksimpananberjangka.vue?vue&type=style&index=0&id=ff8cdc12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8cdc12",
  null
  
)

export default component.exports